import { render, staticRenderFns } from "./GetStats.vue?vue&type=template&id=7771c144&scoped=true&"
import script from "./GetStats.vue?vue&type=script&lang=js&"
export * from "./GetStats.vue?vue&type=script&lang=js&"
import style0 from "./GetStats.vue?vue&type=style&index=0&id=7771c144&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7771c144",
  null
  
)

export default component.exports